import React from 'react';
import PropTypes from 'prop-types';
import { Row, FetchSelect } from 'Common';
import { useTheme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  companyOption: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  companyLogo: {
    height: '35px',
    width: '35px',
    'object-fit': 'contain',
    marginRight: theme.spacing(1.25),
  },
}));

function Option({ data, innerRef, innerProps, isFocused, setValue }) {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <div
      className={classes.companyOption}
      onClick={() => setValue(data)}
      ref={innerRef}
      {...innerProps}
      style={
        isFocused
          ? {
              background: theme.palette.grey[100],
              color: theme.palette.info.main,
            }
          : null
      }
    >
      <Row center>
        {data.logo && (
          <img src={data.logo} alt="avatar" className={classes.companyLogo} />
        )}
        {data.value}
      </Row>
    </div>
  );
}

const companySelectStyles = {
  container: (base) => ({
    ...base,
    height: '38px',
    'font-size': '16px',
    'letter-spacing': '-1px',
    'margin-bottom': '15px',
  }),
  placeholder: (base) => ({
    ...base,
    'font-size': '0.875rem',
    'letter-spacing': 'normal',
    'word-spacing': 'normal',
  }),
  input: (base) => ({
    ...base,
    opacity: 1,
  }),
};

export default function CompanyFilter({
  inputValue,
  onInputChange,
  onBlur,
  menuIsOpen,
  onChange,
  loadOptions,
  width = '100%',
}) {
  return (
    <FetchSelect
      inputValue={inputValue}
      onChange={onChange}
      loadOptions={loadOptions}
      cacheOptions
      placeholder="Company Name"
      width={width}
      isClearable
      components={{
        displayName: 'Option',
        Option,
      }}
      fontSize="16px"
      menuIsOpen={menuIsOpen}
      onInputChange={onInputChange}
      onBlur={onBlur}
      blurInputOnSelect
      styles={companySelectStyles}
    />
  );
}

CompanyFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  width: PropTypes.string,
};
